export const CHECKOUT_URL =
  'https://inventos-carton-y-circuitos.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/uArpfB4Vdf697zCw89vXYL/Kit_creativo_de_inventos_de_carton_para_ninos.png'

export const PRODUCT_NAME = 'MEGA PACK: INVENTOS, CARTÓN Y CIRCUITOS'

export const PRICE = '$19.990'

export const BONUS_TOTAL = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: 'layers' as const,
    title: 'IDEAS DISPERSAS',
    desc: 'Guardás videos de experimentos, manualidades, robots y proyectos con cartón, pero después no encontrás materiales, instrucciones claras o actividades apropiadas para su edad.',
  },
  {
    icon: 'help' as const,
    title: 'NO SABÉS QUÉ ACTIVIDAD ELEGIR',
    desc: 'Circuitos, máquinas, robots, construcciones, experimentos… hay tantas opciones que resulta difícil saber por dónde empezar y cómo mantener su interés.',
  },
  {
    icon: 'route' as const,
    title: 'TE FALTA UNA RUTA',
    desc: 'Querés que tus hijos se diviertan mientras desarrollan habilidades científicas, creatividad y pensamiento lógico, pero necesitás actividades organizadas y fáciles de seguir.',
  },
  {
    icon: 'screen' as const,
    title: 'SIGUEN LAS PANTALLAS',
    desc: 'Querés ofrecerles algo diferente, pero pasan los días y terminan recurriendo nuevamente al celular, la televisión o la tablet.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    icon: 'box' as const,
    title: 'EL MUNDO MÁGICO DEL CARTÓN',
    desc: 'Construí un laberinto de canicas, un puente resistente, una catapulta, una torre, un autito de cartón y un futbolín de mesa mientras descubrís estructuras, equilibrio y movimiento.',
  },
  {
    icon: 'cog' as const,
    title: 'MÁQUINAS Y MECANISMOS INCREÍBLES',
    desc: 'Descubrí cómo funcionan las máquinas construyendo una grúa, un ascensor, un molino de viento, engranajes, una máquina de dibujos giratorios y una garra mecánica.',
  },
  {
    icon: 'bulb' as const,
    title: 'CIRCUITOS, LUCES Y ENERGÍA',
    desc: 'Explorá la electricidad con un primer circuito LED, una linterna, una casa iluminada, un semáforo manual, pruebas de conductores y aislantes y una tarjeta luminosa.',
  },
  {
    icon: 'bot' as const,
    title: 'ROBOTS Y MOVIMIENTOS SORPRENDENTES',
    desc: 'Creá una mano robótica, un robot dibujante, una araña mecánica, un brazo articulado, un vehículo impulsado por globo y un robot explorador de obstáculos.',
  },
  {
    icon: 'flask' as const,
    title: 'EXPERIMENTOS QUE PARECEN MAGIA',
    desc: 'Descubrí fenómenos sorprendentes construyendo un periscopio, un caleidoscopio, un teatro de sombras, un submarino flotante, un teléfono de hilo y un cohete de aire.',
  },
  {
    icon: 'rocket' as const,
    title: 'EL GRAN LABORATORIO DE INVENTORES',
    desc: 'Poné a prueba tu creatividad con un pinball, una máquina expendedora, una ciudad iluminada, un parque de diversiones, una reacción en cadena y tu propio invento extraordinario.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    icon: 'recycle' as const,
    title: '10 INVENTOS EXTRAS CON MATERIALES RECICLADOS',
    desc: 'Diez proyectos adicionales para transformar objetos cotidianos en creaciones divertidas, como barcos, aviones, helicópteros, laberintos, pistas y organizadores.',
    value: '$7.990',
  },
  {
    icon: 'cards' as const,
    title: '20 TARJETAS DE DESAFÍOS CREATIVOS',
    desc: 'Veinte misiones para estimular la imaginación, resolver problemas, experimentar con materiales y desarrollar nuevas ideas mediante pequeños retos.',
    value: '$5.990',
  },
  {
    icon: 'notebook' as const,
    title: 'CUADERNO DE EXPERIMENTOS DIVERTIDOS',
    desc: 'Cinco experiencias para investigar flotación, colores, resistencia del papel, sombras y movimiento, con actividades de observación y reflexión.',
    value: '$6.990',
  },
  {
    icon: 'puzzle' as const,
    title: 'JUEGOS Y ACTIVIDADES PARA APRENDER CIENCIA',
    desc: 'Cinco juegos educativos para descubrir inventos, construir en equipo, ejercitar la memoria, investigar máquinas y aprender ciencia jugando.',
    value: '$8.990',
  },
  {
    icon: 'calendar' as const,
    title: 'RETO DE 7 DÍAS: ¡SOY UN PEQUEÑO INVENTOR!',
    desc: 'Un desafío diario para explorar materiales, construir, experimentar, diseñar una idea propia y presentar un invento al finalizar la semana.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'screenOff' as const,
    title: 'MENOS PANTALLAS',
    desc: 'Ofrecé actividades entretenidas que inviten a construir, experimentar y disfrutar del tiempo libre con propuestas diferentes.',
  },
  {
    icon: 'atom' as const,
    title: 'MÁS APRENDIZAJE PRÁCTICO',
    desc: 'Ayudá a tus hijos a explorar ciencia, tecnología, ingeniería, arte y matemáticas mediante proyectos que pueden realizar con materiales accesibles.',
  },
  {
    icon: 'sparkles' as const,
    title: 'MÁS CREATIVIDAD Y CONFIANZA',
    desc: 'Cada construcción les permite imaginar soluciones, probar ideas, aprender de los errores y sentir orgullo por lo que logran crear.',
  },
  {
    icon: 'family' as const,
    title: 'MOMENTOS PARA COMPARTIR',
    desc: 'Transformá una tarde común en una experiencia de descubrimiento, diversión y conexión familiar, mientras acompañás su curiosidad.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Tengo dos varones de 7 y 10 años y los fines de semana eran una pelea constante por la tablet. Empezamos con el laberinto de canicas del primer tomo y terminamos armando el futbolín de mesa entre los tres. Ahora son ellos los que me piden "hacer un invento" el sábado a la tarde. Las instrucciones son clarísimas y casi todo lo hicimos con cajas que teníamos en casa.',
    author: 'Valeria Sosa',
    role: 'Mamá de Benjamín (7) y Thiago (10), 38 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Soy maestra de 4.º grado y uso los proyectos en el taller de ciencias. El tomo de circuitos fue un antes y un después: cuando se prendió el primer LED, el aula entera aplaudió. Me sirve que cada actividad explique qué se aprende y qué materiales hacen falta, porque organizo la clase en diez minutos. Las tarjetas de desafíos las uso para los que terminan antes.',
    author: 'Mariela Quiroga',
    role: 'Docente de nivel primario, 44 años',
    location: 'Mendoza, Argentina',
  },
  {
    quote:
      'Trabajo todo el día y a la noche no tenía energía para inventar actividades. Con el reto de 7 días mi hija de 8 años tuvo una propuesta distinta cada tarde y el domingo nos presentó su propio invento: una alcancía con palanca. Verla tan orgullosa explicando cómo funcionaba me emocionó. Son 20 o 30 minutos que pasamos juntas sin celular.',
    author: 'Florencia Ledesma',
    role: 'Mamá de Martina (8), 35 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'A mi hijo de 11 años le encantan los robots, pero los kits que venden son carísimos. Con el tomo de robots armamos la mano robótica con sorbetes e hilo y el vehículo impulsado por globo. Lo mejor es que entiende por qué se mueve cada pieza y ya empezó a modificar los diseños solo. Para mí, que no soy de ciencias, fue fácil acompañarlo.',
    author: 'Sebastián Ojeda',
    role: 'Papá de Joaquín (11), 41 años',
    location: 'La Plata, Argentina',
  },
  {
    quote:
      'Cuido a mis nietos dos tardes por semana y no sabía qué hacer con ellos más allá de la tele. Elegimos los experimentos que parecen magia: el periscopio y el teatro de sombras fueron un éxito. Los más chicos, de 5 y 6 años, pintan y pegan, y el mayor arma las partes más difíciles. Ahora mis tardes con ellos son las más esperadas de la semana.',
    author: 'Graciela Benítez',
    role: 'Abuela de tres pequeños inventores, 63 años',
    location: 'San Miguel de Tucumán, Argentina',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. Los proyectos están organizados para comenzar con actividades sencillas y avanzar progresivamente.',
  },
  {
    q: '¿Qué van a aprender mis hijos?',
    a: 'Construcciones con cartón, mecanismos, circuitos básicos, robótica creativa, experimentos científicos y diseño de inventos.',
  },
  {
    q: '¿Incluye actividades prácticas?',
    a: 'Sí. Incluye 36 proyectos distribuidos en 6 tomos y actividades adicionales en los 5 bonos.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los cinco bonos están incluidos gratuitamente con la compra.',
  },
  { q: '¿Es un pago único?', a: 'Sí. Realizás un solo pago, sin mensualidades.' },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. El acceso al material digital se entrega después de completar la compra.',
  },
  {
    q: '¿Es adecuado para cualquier edad?',
    a: 'Está pensado para niños de 5 a 12 años, con acompañamiento adulto y adaptaciones según su edad y habilidades.',
  },
  {
    q: '¿Podemos aprender a nuestro ritmo?',
    a: 'Sí. Pueden elegir los proyectos y realizarlos según su tiempo e intereses.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Podés escribir a soportescmdigital@gmail.com.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Micaela Fernández', city: 'Córdoba', minutes: 2 },
  { name: 'Sofía Romero', city: 'Rosario', minutes: 4 },
  { name: 'Brenda Gómez', city: 'Buenos Aires', minutes: 7 },
  { name: 'Julián Díaz', city: 'Mendoza', minutes: 11 },
  { name: 'Paula Medina', city: 'La Plata', minutes: 15 },
  { name: 'Milagros Torres', city: 'Mar del Plata', minutes: 19 },
  { name: 'Lucía Acosta', city: 'Salta', minutes: 24 },
  { name: 'Ayelén Molina', city: 'San Miguel de Tucumán', minutes: 29 },
  { name: 'Nahuel Ríos', city: 'Neuquén', minutes: 33 },
  { name: 'Julieta Herrera', city: 'Santa Fe', minutes: 40 },
]
